import { useState } from "react";
import { ConfirmModal } from "../modals/ConfirmModal";
import { I18n } from "@/i18n/I18n";
import { LoadingSpinner } from "../LoadingSpinner";
import { LoadingModal } from "../LoadingModal";
import { Trash2 } from "lucide-react";

export function DeleteButton(props: { model: string, onDelete: () => Promise<unknown>, title: string, disabled?: boolean, size?: 'small' | 'medium', label?: string }) {
  const { title, onDelete, model, disabled, size = 'medium', label } = props;
  const [showModal, setShowModal] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const confirmMessage = I18n.get('areYouSureDeleteModel', { model });
  const confirmTitle = I18n.get('deleteModel', { model, title });

  const className = label ? 'btn btn-sm btn-danger' : `btn-red-light ${size === 'small' ? 'icon-button-small' : 'fusa-btn-medium-icon'}`;

  const onConfirm = async () => {
    setDeleting(true);
    await onDelete();
    setDeleting(false);
    setShowModal(false);
  };

  return (
    <>
      <button className={className} onClick={() => setShowModal(true)} title={confirmTitle} disabled={disabled || deleting}>{deleting ? <LoadingSpinner /> : (label ?? <Trash2 />)}</button>
      {deleting && <LoadingModal message={I18n.get('deleting')} />}
      {showModal && !deleting && (
        <ConfirmModal title={confirmTitle} confirmMessage={confirmMessage} onConfirm={onConfirm} setShowModal={setShowModal} />
      )}
    </>
  );
}